import React from 'react';
import MagicForm from '../../../../../Components/Form/MagicForm';
import { ItemScheme } from '../../../../../Components/Form/MagicFormItem';
import { MagicField } from '../../../../../Enums/MagicField.enum';
import { useDENTContext } from '../../../Services/DENTContext';
import { DENTITION_VISIT_TYPE_OPTIONS } from '../../../Helpers/medicalExamination/medicalExaminationTypeOptions';
import useApiClient from '../../../../Base/Hooks/useApiClient';
import useNotification from '../../../../../Hooks/useNotification.hook';
import { useCreateDentMedicalExaminationMutation } from '../../../../../graphql/graphql';

interface Props {
	onSuccess: () => void;
}

interface MedicalExaminationCreateValues {
	type: (typeof DENTITION_VISIT_TYPE_OPTIONS)[number];
}

const DENTDentalCrossStartMedicalExaminationForm = ({ onSuccess }: Props) => {
	const [createMedicalExamination] = useCreateDentMedicalExaminationMutation();
	const {
		dentitionId,
		setActiveMedicalExaminationId,
		setMedicalExaminationNotificationShown,
		patientId,
	} = useDENTContext();
	const { displayGQLError } = useApiClient();
	const { showNotificationSuccess } = useNotification();

	const handleSubmit = async ({ type }: MedicalExaminationCreateValues) => {
		if (dentitionId) {
			const response = await createMedicalExamination({
				input: { type: type.value, patientId },
			});

			if ('error' in response) {
				displayGQLError(response);
			} else {
				showNotificationSuccess({
					content:
						'patientTreatment.meddiDENT.dentalCross.actions.dentitionVisit.startSuccess',
				});
				setActiveMedicalExaminationId(
					response.data.createMedicalExamination?.id,
				);
				setMedicalExaminationNotificationShown(true);
				onSuccess();
			}
		}
	};

	const formScheme: ItemScheme[] = [
		{
			type: MagicField.SELECT,
			key: 'type',
			title:
				'patientTreatment.meddiDENT.dentalCross.actions.dentitionVisit.selectType',
			children: DENTITION_VISIT_TYPE_OPTIONS,
			settings: {
				required: true,
				portal: true,
			},
		},
	];

	return (
		<MagicForm
			formScheme={formScheme}
			onSubmit={handleSubmit}
			submitText={
				'patientTreatment.meddiDENT.dentalCross.actions.dentitionVisit.start'
			}
		/>
	);
};

export default DENTDentalCrossStartMedicalExaminationForm;
